import {API_URL_STORE} from './urls';

const getApiLiveness = () => window.axios

    .get(API_URL_STORE + 'liveness')

    .then((response) => response.data)

    .catch((error) => {
        throw error;
    });

export {getApiLiveness};
